import { CLSTesting } from 'util/setLocalStorageTesting'

export const enterSuggestionExam = (user, props, data) => {
  CLSTesting()
  if (props && data) {
    let setState = {
      data: data,
      typeExam: 'generalExam'
    }
    return props?.history.push({ pathname: `/testing/${data.id}`, state: setState })
  } else {
    return
  }
}